import { createGlobalStyle } from 'styled-components/macro';

export const ReactRndStyles = createGlobalStyle`
  .resizable-timeline-item {
    position: relative;
    height: 24px;
  }
`;
